import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  fonts: {
    heading: '"Noto Serif JP", "Noto Serif", system-ui, Avenir, Helvetica, Arial, sans-serif',
    body: '"Noto Serif JP", "Noto Serif", system-ui, Avenir, Helvetica, Arial, sans-serif',
  },
});

export default theme;
